export function parseNumberInput(v: string): number | "" {
  if (v.trim() === "") return ""
  const n = Number(v)
  return Number.isFinite(n) ? n : ""
}

export function ensureBetweenArray(v: any): [any, any] {
  return Array.isArray(v) && v.length === 2 ? [v[0], v[1]] : ["", ""]
}
